import React from 'react';
import { IconArrowRightBold, Stack, Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { CheckBox, CheckBoxProps } from '@widgets/authentication';

export interface CheckboxListItemProps extends CheckBoxProps {
  label: string;
  onView?: () => void;
}

export const CheckboxListItem: React.FC<React.PropsWithChildren<CheckboxListItemProps>> = ({
  label,
  onView,
  ...props
}) => {
  return (
    <Stack direction={'row'} justify='space-between' align='center'>
      <CheckBox {...props}>
        <CheckBoxLabel variant='Body_15_Medium'>{label}</CheckBoxLabel>
      </CheckBox>
      {onView && (
        <IconButton type='button' onClick={onView}>
          <IconArrowRightBold size={24} v3Color='gray300' />
        </IconButton>
      )}
    </Stack>
  );
};

const CheckBoxLabel = styled(Text)`
  margin-left: 8px;
`;

const IconButton = styled.button`
  cursor: pointer;
`;
